import React, { useEffect } from 'react'

import { ROUTES } from 'helpers/constants'
import { useAuthState } from 'hooks'

import AuthModal from 'components/AuthModal'

const { LANDING } = ROUTES

const AuthPage = ({ history }) => {
  const { user } = useAuthState()

  useEffect(() => {
    if (user) {
      history.push(LANDING)
    }
  }, [user, history])

  return user ? null : <AuthModal show={true} />
}

export default AuthPage
